var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5F2596",
    d: "M4.286 15.75v-5.379l2.572 1.338v5.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGg0)",
    d: "M19.715 15.75v-5.379l-2.572 1.338v5.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGg1)",
    d: "m12 14.194l-5.142 2.949v-5.4L12 8.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5E2693",
    d: "m12 14.194l5.143 2.949v-5.4L12 8.846z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGg2)",
    d: "m6.858 11.743l-2.572-1.38L11.983 6l7.732 4.363l-2.572 1.38l-5.147-2.872z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGg0",
    x1: 12,
    x2: 12,
    y1: 6,
    y2: 17.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#E26891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D45AC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B071D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGg1",
    x1: 12,
    x2: 12,
    y1: 6,
    y2: 17.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#EF7C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EA6D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B961DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGg2",
    x1: 12,
    x2: 12,
    y1: 6,
    y2: 11.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEC985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#FCA143"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGg);
export default __webpack_public_path__ + "static/media/gg.465f358ce311b771d65e017afdb2a5ff.svg";
export { ForwardRef as ReactComponent };